import { ChangeEvent } from 'react';
import { Link, Stack, Typography } from '@mui/material';
import { Checkbox } from 'common';
import { PostSignupAgreement } from '../usePostSignupAgreements';

type ConsentStepKey = 'taxDetails' | 'remittance';

const PURPOSE_BY_STEP: Record<ConsentStepKey, string> = {
    taxDetails: 'so my TIN can be verified',
    remittance: 'so my bank account can be verified',
};

export function ServiceAgreementConsent({
    agreement,
    stepKey,
    accepted,
    onAcceptedChange,
}: {
    agreement: PostSignupAgreement;
    stepKey: ConsentStepKey;
    accepted: boolean;
    onAcceptedChange: (accepted: boolean) => void;
}) {
    const name = agreement.serviceAgreement?.Name;

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onAcceptedChange(event.target.checked);
    };

    return (
        <Stack>
            <Checkbox
                checked={agreement.IsSigned || accepted}
                disabled={agreement.IsSigned}
                onChange={handleChange}
                testId={`post-signup-agreement-${agreement.ServiceAgreementId}`}
                labelAsNode={
                    <Typography component="span">
                        I agree to the{' '}
                        {agreement.agreementUrl ? (
                            <Link href={agreement.agreementUrl} target="_blank" rel="noopener noreferrer">
                                {name}
                            </Link>
                        ) : (
                            name
                        )}{' '}
                        {PURPOSE_BY_STEP[stepKey]}.
                    </Typography>
                }
            />
            {!agreement.IsSigned && !accepted && (
                <Typography variant="body2" color="text.secondary">
                    You must accept this agreement to continue.
                </Typography>
            )}
        </Stack>
    );
}
